class Controller {
  constructor($stateParams, Sections) {
    "ngInject";

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.plansSections;
    this.captainParams = { captain: $stateParams.id };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainInvoices/captainInvoices.controller.js